(function() { window.GUID_a14d2a2d_16db_4b42_af5e_1268c6fd7c86 = { getGuid: function() { return "a14d2a2d-16db-4b42-af5e-1268c6fd7c86"; } }; })();
//function LoadFile(fileType, filePath, callback) {
//    var scriptTag = document.createElement(fileType);
//    scriptTag.onload = function (loadEvent) {
//        if (callback != null) {
//            callback.call(this);
//        }
//    };
//    scriptTag.type = "text/javascript";
//    (<any>scriptTag).src = filePath + "?forcedownload=" + new Date().getTime();
//    document.getElementsByTagName("head")[0].appendChild(scriptTag);
//}

//# sourceMappingURL=cs.dynamicfile.js.map
